module.exports = __webpack_public_path__ + "img/4.add830d3.jpg";